<template>
    <component :is="component" :to="to" :href="href" class="btn disabled:opacity-50" :disabled="disabled">
        <svg v-if="back" class="btn-icon mr-2 rotate-180" xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10">
            <path d="M17.333,4.42l5,5.387H18.189V24.42H16.476V9.806H12.333Z" transform="translate(24.42 -12.333) rotate(90)" fill="currentColor"/>
        </svg>
        <span><slot></slot></span>
        <svg v-if="!back" class="btn-icon ml-2" xmlns="http://www.w3.org/2000/svg" width="20" height="10" viewBox="0 0 20 10">
            <path d="M17.333,4.42l5,5.387H18.189V24.42H16.476V9.806H12.333Z" transform="translate(24.42 -12.333) rotate(90)" fill="currentColor"/>
        </svg>
    </component>
</template>

<script setup>
const props = defineProps({
    to: String,
    href: String,
    back: Boolean,
    disabled: Boolean
})

const component = computed(() => {
  if (props.to || props.href) return defineNuxtLink({})
  return 'button'
})
</script>

<style>
.btn {
  @apply text-white uppercase font-sans font-bold text-xs px-4 py-2.5 rounded-full inline-flex items-center tracking-wider justify-between;

  &:focus-visible {
    @apply outline-none ring-2 ring-blue ring-offset-2 ring-offset-background
  }

  &.btn-primary {
    @apply bg-primary;
  }

  &.btn-outline {
    @apply bg-transparent border-2 border-primary text-primary;
  }

  &.btn-secondary {
    @apply bg-secondary;
  }

  .btn-icon {
    @apply transition-transform duration-300 ease-in-out;
    width: 16px;
    height: 8px;
  }

  &:hover, &:focus {
    .btn-icon {
        &:last-child {
            @apply translate-x-1.5;
        }
        &:first-child {
            @apply -translate-x-1.5;
        }
    }

    &:active {
      .btn-icon {
        &:last-child {
            @apply translate-x-2;
        }
        &:first-child {
            @apply -translate-x-2;
        }
      }
    }
  }

  @screen lg {
    @apply text-sm px-5 py-3;

    .btn-icon {
      width: 20px;
      height: 10px;
    }
  }
}


.dotted-spaced-border {
  background-image: linear-gradient(to right, black 33%, rgba(255,255,255,0) 0%);
  background-position: bottom;
  background-size: 3px 1px;
  background-repeat: repeat-x;
}


.is-open [data-collapse-btn] svg {
  @apply rotate-45;
}
</style>
